import tinycolor from 'tinycolor2';

var Theme;
(function (Theme) {
  Theme.getLight = function (primaryColor) {
    return {
      switchBackground: tinycolor('black').setAlpha(0.2).toHslString(),
      switchActiveBackground: '$primary',
      switchFocusBorder: primaryColor.helpers.pickScale(8),
      switchThumb: tinycolor('white').setAlpha(0.87).toHslString()
    };
  };
  Theme.getDark = function (primaryColor) {
    return {
      switchBackground: tinycolor('white').setAlpha(0.2).toHslString(),
      switchActiveBackground: '$primary',
      switchFocusBorder: primaryColor.helpers.pickScale(11),
      switchThumb: tinycolor('black').setAlpha(0.87).toHslString()
    };
  };
})(Theme || (Theme = {}));

export { Theme };
